import { useCallback } from "react";
import usePlanFeatureValue from "./use-plan-features";
import consts, { TypeCanvasElement } from "shared/consts";
import { isIdOfType } from "frontend/canvas-designer-new/elements/canvas-elements-utils";
import { useAtomValue } from "jotai";
import { stageRefAtom } from "state-atoms";
import { countCanvasStageElementsPerType } from "utils/canvas-utils";
import { PlanFeatureName } from "shared/datamodel/schemas";

export default function useElementsLimitPerPlanFeature(featureName: PlanFeatureName) {
  const stageRef = useAtomValue(stageRefAtom);
  const limit = usePlanFeatureValue(featureName) as number;

  const canAddElements = useCallback(
    (elementIds: string[]) => {
      const elementTypes = getElementTypesForFeature(featureName);
      if (elementTypes.length === 0) return true; // no limit

      const countPerElementType = countCanvasStageElementsPerType(stageRef?.current);

      const numberOfExistingElements = elementTypes.reduce((sum, type) => sum + (countPerElementType[type] ?? 0), 0);

      const relevantElementIds = elementIds.filter((id) => elementTypes.some((type) => isIdOfType(id, type)));

      return relevantElementIds.length === 0 || relevantElementIds.length + numberOfExistingElements <= limit;
    },
    [featureName, limit, stageRef]
  );

  return {
    limit,
    canAddElements,
  };
}

function getElementTypesForFeature(featureName: PlanFeatureName): TypeCanvasElement[] {
  switch (featureName) {
    case PlanFeatureName.MONDAY_INTEGRATION_LIMIT: {
      return [consts.CANVAS_ELEMENTS.INTEGRATION, consts.CANVAS_ELEMENTS.MONDAY_TASK];
    }
    default: {
      return [];
    }
  }
}
